import React from 'react'

import Input from '../input'
import Select from '../newSelect/Select'

import styles from './weightInput.module.scss'

const POUND_KG = 2.2046

const UNITS = [{
  value: 'kg',
  label: 'KG'
}, {
  value: 'lb',
  label: 'LB'
}]

const convertToGrams = (value) => {
  const weight = +value?.value
  if (value?.unit?.value === UNITS[0]?.value) {
    return Math.round(weight * POUND_KG)
  } else {
    return Math.round(weight)
  }
}

const convertToInput = (weight) => {
  if (!isNaN(weight)) {
    return {
      unit: UNITS[0],
      value: (+weight / POUND_KG).toFixed(2)
    }
  } else {
    return {
      unit: UNITS[0],
      value: ''
    }
  }
}

const convertToPound = (grams) => {
  return Math.round(grams / 1000 * POUND_KG)
}

const convertToKG = (grams) => {
  return (grams / POUND_KG).toFixed(2)
}

const WeightInput = ({ placeholder, value, onChange }) => {
  if (!value) {
    value = {
      unit: UNITS[0],
      value: ''
    }
  }

  const changeUnit = (_unit) => {
    const weight = +value?.value
    if (value?.unit?.value !== _unit?.value) {
      if (value?.unit?.value === UNITS[0]?.value) {
        onChange({ unit: _unit, value: (weight * POUND_KG).toFixed(2) })
      } else {
        onChange({ unit: _unit, value: (weight / POUND_KG).toFixed(2) })
      }
    }
  }

  return (
    <div className={styles.container}>
      <Input type='number' placeholder={placeholder} value={value?.value} onChange={(e) => onChange({ unit: value?.unit, value: e.target.value })} />
      <Select
        value={value?.unit}
        options={UNITS}
        onChange={v => changeUnit(v)}
      />
    </div>
  )
}

export default WeightInput
export { convertToGrams, convertToInput, convertToPound, convertToKG }
